<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <Modal
    :title="modalTitle"
    :closable="false"
    :mask-closable="false"
    @on-visible-change="onVisibleChange"
    v-model="modalShowHide"
    class="modal-setting"
    :width="640"
    footer-hide
    class-name="vertical-center-modal"
  >
    <!--    <div style="background-color: #F4F8FF;">-->
    <div style="background-color: white">
      <div class="w-full">
        <div class="m-auto bg-white" style="width: 600px;">
          <div class="m-auto flex j-center" style="width: 600px;padding-top: 20px">
            <div style="width: 600px;">
              <up-load-image @uploadSuccess="uploadCoverImageSuccess" accept="image/*"
                             picurl="common/desc/"
                             style="width:600px;">
                <template v-slot:tip>
                  <div style="position: relative">
                    <div class="flex-column a-center j-center"
                         style="width: 600px;height: 450px;background-color: #F6F9FF;cursor: pointer"
                         v-if="!coverUrl">
                      <img alt="" src="../../../../assets/common/ic_upload_picture@2x.png"
                           key="111"
                           style="width: 96px;height: 96px">
                      <span class="m-t-5  color-66">上传图片</span>
                    </div>
                    <div class="o-hidden flex a-center j-center"
                         style=" position: relative;left: 0;top: 0;width: 600px;height: 450px;"
                         v-if="coverUrl">
                      <img :src="coverUrl" class="w-full"
                           key="222"
                           style="min-height: 450px;background-color: #F6F9FF;object-fit: cover"
                      />
                    </div>
                    <img @click.stop="onImgDelClick"
                         class="w-24 h-24 p-3 absolute right--12 top--12"
                         v-if="coverUrl"
                         src="../../../../assets/common/ic_shanchu_red_sub.png">
                  </div>
                </template>
              </up-load-image>
            </div>
          </div>
          <div class="color-66 fs-12 m-t-15">
            图片格式为jpg或png,图片比例为4:3,图片大小不超过5Mb
          </div>
          <div class="m-t-10">
            <Row :gutter="15">
              <Col span="12">
                <class-vertical-choose-widget :objData="objData" :srcType="6"
                                              direction="horizontal"></class-vertical-choose-widget>
              </Col>
              <Col span="12">
                <div class="w-full" style="height: 80px;">
                  <span class="bold fs-14 color-33">图片标题:</span>
                  <Input class="m-t-10 w-full" maxlength="60" placeholder="图片标题" type="text"
                         v-model="title"/>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <div class="w-full flex j-center p-b-10">
        <Button @click="onCancelClick" style="width: 100px">取消</Button>
        <Button @click="onPicSaveClick" style="margin-left: 50px;width: 100px" type="primary">确定
        </Button>
      </div>

      <!--      <div style="position: sticky;bottom: 0;left: 0;background-color: #F4F8FF;">-->
      <!--        <div class="m-auto flex a-center j-end bg-white"-->
      <!--             style="width: 820px;height: 64px;box-shadow: 0px 0px 8px 0px rgba(1, 0, 52, 0.12);">-->
      <!--          <Button @click="onCancelClick" style="width: 76px">取消</Button>-->
      <!--          <Button @click="onPicSaveClick" class="m-l-20" style="  margin-right: 38px;width: 76px" type="primary">保存-->
      <!--          </Button>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
  </Modal>
</template>

<script>
import BasePageComponent from '@/components/common/BasePageComponent'
import UpLoadImage from '@/components/common/UpLoadImage'
import {mapActions, mapMutations} from 'vuex'
import ClassVerticalChooseWidget from '../../../../components/common/ClassVerticalChooseWidget'

export default {
  name: 'UploadEditPicWidget',
  components: {
    ClassVerticalChooseWidget,
    BasePageComponent,
    UpLoadImage
  },
  props:{
    onOk:Function,
    onCancel:Function,
  },
  data () {
    return {
      //显示隐藏
      modalShowHide: false,
      modalTitle: '上传图片',
      modalType:'upload',     //upload  edit

      //编辑弹框获取img信息
      imgId:0,

      title: '',
      coverUrl: '',
      width: 0,
      height: 0,
      objData: {
        classId: 0,
        groupId: 0,
        init: false
      },
      dCGInfo: {
        classId: 0,
        groupId: 0
      },
    }
  },
  computed: {},
  mounted () {
    this.init()
  },
  methods: {
    init () {
    },
    /**
     *上传封面
     * @param data
     */
    uploadCoverImageSuccess (data) {
      if (data && data.length) {
        console.log(data[0])
        this.coverUrl = data[0].url
        this.width = data[0].width
        this.height = data[0].height
        this.title = data[0].oldname || ''
      }
    },
    onPicSaveClick () {
      if (!this.coverUrl) {
        return this.$Message.info('请上传图片')
      }
      if (!this.title) {
        return this.$Message.info('请输入图片标题')
      }
      let pic = {
        title: this.title,
        url: this.coverUrl,
        width: this.width,
        height: this.height,
        groupId: this.objData.groupId || 0,
        categoryId: this.objData.classId || 0,
        desc: ''
      }
      if (this.modalType==='upload'){           //上传图片
        let params = [pic]
        this.addNewPic(params).then(res => {
          if (res.code === 0) {
            this.hide()
            if (this.onOk){
              this.onOk()
            }
          }
        })
      }else{                                    //编辑图片
        let id = this.imgId
        let params = pic
        this.editPic({id, params}).then(res => {
          if (res.code === 0) {
            this.hide()
            if (this.onOk){
              this.onOk()
            }
          }
        })
      }
    },
    onCancelClick () {
      // this.$router.go(-1)
      // this.closeTag({
      //   name: 'UploadPic'
      // })
      this.hide()
    },
    onImgDelClick () {
      this.coverUrl = ''
    },
    async getDefaultCGInfo () {
      let params = {
        type: 6
      }
      let result = await this.getCategoryLists(params)
      if (result.code === 0) {
        let item = result.data.find(e => {
          return e.isDefault === 1
        })
        if (item && item.id) {
          this.dCGInfo.classId = item.id
          let p = {
            categoryId: item.id,
            type: 6
          }
          let res = await this.getGroupLists(p)
          if (res.code === 0) {
            let itemInfo = res.data.find(e => {
              return e.isDefault === 1
            })
            if (itemInfo && itemInfo.id) {
              this.dCGInfo.groupId = itemInfo.id
              this.objData = {
                classId: this.dCGInfo.classId,
                groupId: this.dCGInfo.groupId,
                init: true
              }
            }
          }
        }
      }
    },

    onVisibleChange (status) {
      if (status) {
        if (this.modalType=== 'upload')
          this.getDefaultCGInfo()
      } else {
        this.title = ''
        this.coverUrl = ''
        this.width = 0
        this.height = 0
        this.objData = {
          classId: 0,
          groupId: 0,
          init: false
        }
        this.dCGInfo = {
          classId: 0,
          groupId: 0
        }
      }
    },

    getPicDetails () {
      let id = this.imgId
      let params = {}
      this.getPicDetail({id, params}).then(res => {
        if (res.code === 0) {
          let data = res.data
          this.title = data.title || ''
          this.coverUrl = data.url || ''
          this.width = data.width || 0
          this.height = data.height || 0
          this.objData = {
            classId: data.categoryId || 0,
            groupId: data.groupId || 0,
            init: true
          }
        }
      })
    },

    showUpload () {
      this.modalTitle = '上传图片'
      this.modalType = 'upload'
      this.modalShowHide = true
    },
    showEdit(imgId){
      this.modalTitle= '编辑图片'
      this.modalType = 'edit'
      this.imgId = imgId
      if (this.imgId) {
        this.getPicDetails()
      }
      this.modalShowHide = true
    },

    hide () {
      this.modalShowHide = false
    },
    ...mapMutations([
      'closeTag'
    ]),
    ...mapActions([
      'addNewPic',
      'getCategoryLists',
      'getGroupLists',
      'getPicDetail',
      'editPic',
    ]),
  },

}
</script>

<style lang="scss" scoped>
.hoverstyle {
  &:hover {
    .showdel {
      display: block;
    }
  }

  .showdel {
    display: none;
  }
}

.modal-setting ::v-deep {

  .ivu-modal-header-inner {
    display: flex;
    justify-content: center;
    font-weight: bold;
  }

  .ivu-modal-body {
    padding: 0;
    display: flex;
    justify-content: center;
    align-content: center;
  }

  //标题下横线
  .ivu-modal-header {
    border-bottom: none;
    background-color: #D1D2D3;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }

  //确认取消按钮上面红线
  .ivu-modal-footer {
    border-top: none;
  }
}

</style>
